import React from "react";
import ContentLoader from "react-content-loader";

const VariantsLoader = () => {
  const rows = 3; // Simula 3 productos como en la imagen
  const rowHeight = 100; // Altura de cada fila
  const containerWidth = 900; // Ancho total

  return (
    <ContentLoader
      speed={2}
      width={containerWidth}
      height={rowHeight * rows}
      backgroundColor="#f3f3f3"
      foregroundColor="#e0e0e0"
    >
      {Array.from({ length: rows }).map((_, index) => {
        const yOffset = index * rowHeight;

        return (
          <React.Fragment key={index}>
          

            {/* Checkbox */}
            <rect x="20" y={yOffset + 40} rx="3" ry="3" width="16" height="16" />

            {/* Imagen del producto */}
            <rect x="60" y={yOffset + 20} rx="5" ry="5" width="60" height="60" />

            {/* Código del producto */}
            <rect x="140" y={yOffset + 25} rx="4" ry="4" width="120" height="10" />

            {/* Nombre del producto */}
            <rect x="140" y={yOffset + 45} rx="4" ry="4" width="300" height="15" />

            {/* Precio */}
            <rect x="550" y={yOffset + 45} rx="4" ry="4" width="80" height="15" />

            {/* Link "Revisar variante" */}
            <rect x="780" y={yOffset + 45} rx="4" ry="4" width="120" height="15" />
          </React.Fragment>
        );
      })}
    </ContentLoader>
  );
};

export default VariantsLoader;
